const entries = (value) => Object.entries(value);

export { entries };
//# sourceMappingURL=entries.js.map
